import i18n from './i18n';
import { getTranslatedValue } from './gtin-metadata';
import { NameValueFieldsFragment } from '@/types';

export interface TableData {
  key: string;
  value: string;
}
export interface KeyValueType {
  [key: string]: string | null;
}

export const getParamsFromNameValue = (
  list: NameValueFieldsFragment[],
): KeyValueType => {
  return list.reduce((acc: KeyValueType, item: NameValueFieldsFragment) => {
    if (item.name && item.value) {
      acc[item.name] = item.value;
    }
    return acc;
  }, {});
};

export const transformSaltItemParams = (params: {
  [key: string]: string | boolean | null;
}) =>
  Object.entries(params).reduce((acc: TableData[], [key, value]) => {
    if (typeof value === 'boolean' || (typeof value === 'string' && value)) {
      const translatedKey = i18n.t(`product_spec.${key.toLowerCase()}`);
      acc.push({
        key: translatedKey,
        value: getTranslatedValue(key, value),
      });
    }
    return acc;
  }, []);
